// sposto la navigation del carousel in alto a destra
(function () {
  function moveFeaturedCollectionNav() {
    document.querySelectorAll(".croma-featured-collection").forEach(function (section) {
      var navTarget = section.querySelector(".croma-featured-collection-nav");
      var nav = section.querySelector(".css-slider-navigation-container");

      if (!navTarget || !nav || navTarget.contains(nav)) {
        return;
      }

      navTarget.appendChild(nav);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    moveFeaturedCollectionNav();

    setTimeout(moveFeaturedCollectionNav, 250);
    setTimeout(moveFeaturedCollectionNav, 750);
  });

  document.addEventListener("shopify:section:load", function () {
    setTimeout(moveFeaturedCollectionNav, 250);
  });
})();

// animazione in scroll-reveal GSAP per aggiungere la classe is-inview ad un elemento (rich text image)
(function () {
  if (window.Shopify && Shopify.designMode) {
    return;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  function initCromaImageReveal() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var images = document.querySelectorAll(".rich-text__image figure.custom-croma__image-reveal");

    if (!images.length) {
      return;
    }

    images.forEach(function (image) {
      if (image.dataset.cromaRevealReady === "true") {
        return;
      }

      image.dataset.cromaRevealReady = "true";

      ScrollTrigger.create({
        trigger: image,
        start: "top 95%",
        once: true,
        onEnter: function () {
          image.classList.add("is-inview");
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCromaImageReveal);
  } else {
    initCromaImageReveal();
  }

  document.addEventListener("shopify:section:load", function () {
    initCromaImageReveal();

    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  });
})();